import { API_BASE_URL, DEV_PHONE_IDENTITY } from '../config';
import {
  REQUEST_CLIENT_TOKEN,
  REQUEST_CLIENT_TOKEN_SUCCESS,
  REQUEST_CLIENT_TOKEN_ERROR,
} from './types';

export function clientTokenRequest() {
  return {
    type: REQUEST_CLIENT_TOKEN,
  };
}

export function clientTokenRequestSuccess(payload) {
  return {
    type: REQUEST_CLIENT_TOKEN_SUCCESS,
    payload,
  };
}

export function clientTokenRequestFailure(error) {
  return {
    type: REQUEST_CLIENT_TOKEN_ERROR,
    error,
  };
}

export function fetchClientToken() {
  return async function (dispatch) {
    dispatch(clientTokenRequest());
    try {
      const response = await fetch(`${API_BASE_URL}/token?identity=${DEV_PHONE_IDENTITY}`);
      const data = await response.json();
      dispatch(clientTokenRequestSuccess(data.token));
    } catch (error) {
      console.error("Failed to fetch token from backend:", error);
      dispatch(clientTokenRequestFailure(error));
    }
  };
}

export async function refreshToken(dispatch) {
  const response = await fetch(`${API_BASE_URL}/token?identity=${DEV_PHONE_IDENTITY}`);
  const data = await response.json();
  if (dispatch) {
    dispatch(clientTokenRequestSuccess(data.token));
  }
  return data.token;
}
